import { Component, Input, OnChanges } from '@angular/core';
import { BusyModule } from 'angular2-busy/index';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'cui-spinner',
    templateUrl: './cui-spinner.component.html'
})
export class CUISpinnerComponent {
    @Input() delay: number = 0;
    @Input() minDuration: number = 900;
    @Input() message: string = 'Loading...';
    @Input() subscriptions: Array<Subscription> | Array<Promise<any>>;

    private busyLoading: any;

    ngOnChanges() {
        this.busyLoading = {
            busy: this.subscriptions,
            message: this.message,
            delay: this.delay,
            minDuration: this.minDuration
        }
    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-spinner/cui-spinner.component.ts